import { Box, Tooltip, TooltipProps } from '@mui/material';
import { ReactElement, ReactNode, useState } from 'react';

import { useIsMobile } from '../hooks';

interface PoolTooltipProps extends TooltipProps {
    defaultTitle?: ReactNode;
    preventPropagation?: boolean;
    mobileClickToOpen?: boolean;
}

export const PoolTooltip = (props: PoolTooltipProps): ReactElement => {
    const {
        children,
        title: toolTipTitle,
        defaultTitle,
        mobileClickToOpen = false,
        preventPropagation,
        ...tooltipProps
    } = props;

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const isMobile = useIsMobile();
    const supportMobileClick = mobileClickToOpen && isMobile;

    let title = toolTipTitle;
    if (defaultTitle && !toolTipTitle) {
        title = defaultTitle;
    }

    const toggleMobileTooltip = (event: React.MouseEvent): void => {
        setTooltipOpen(!tooltipOpen);
        event.stopPropagation();
    };

    const tooltip = (
        <Tooltip
            title={title}
            open={supportMobileClick ? tooltipOpen : undefined}
            onClick={supportMobileClick ? toggleMobileTooltip : undefined}
            {...tooltipProps}
        >
            <Box sx={{ display: 'inline-flex' }}>{children}</Box>
        </Tooltip>
    );

    // For mobile click tooltips, there is already event propagation prevention in place
    if (!supportMobileClick && preventPropagation) {
        return (
            <Box sx={{ display: 'inline-flex' }} onClick={event => event.stopPropagation()}>
                {tooltip}
            </Box>
        );
    }

    return tooltip;
};
